import { NetworkStatus } from '@cbridge-utils/network';
import { IScheduleStore } from './schedule.interface';

export const scheduleInitialState: IScheduleStore = {
  data: {},
  listNetworkStatus: NetworkStatus.None,
};
